<template>
    <div class="group-image" v-if="listWithImg.length > 0">
      <div v-for="(item, index) in listWithImg" :key="index" class="img-container">
        <div class="img-body">
          <!-- Verificação do formato da imagem -->
          <div v-if="item.tipo !== 6" style="height: 100%;">
            <img :src="'data:image/jpeg;base64,' + item.base64" class="icone-img">
          </div>
          <div v-else style="display: flex; justify-content: center; align-items: center; height: 100%">
            <div class="icon-file " style="display: flex; justify-content: center; align-items: center; ">
              <i class="fas fa-file" style="font-size: 40px; color: #008148;"></i>
            </div>
          </div>
          <div v-if="item.tipo !== 6" class="edit-img" @click="openPopUpMedia(item.base64)">
            <i class="fas fa-eye"></i>
          </div>
          <div v-else @click="getFileDetails(item.base64, item.extensao, item.descricaoPergunta)" class="edit-img">
            <i class="fas fa-arrow-down" ></i>
          </div>
        </div>
        <div class="img-descricao">
          <div class="descricao">
            {{ item.descricaoPergunta === null ? 'Galeria' : item.descricaoPergunta  + ' ' + item.extensao}}
          </div>
        </div>
      </div>
        <b-modal ref="popupimgfull"
            size="lg"
            centered
            id="add-edit-form"
            :hide-footer="true"
            :no-close-on-backdrop="true"
            :no-close-on-esc="true"
            :hide-header=" true"
            body-class="rounded-1rem"
            content-class="rounded-1rem"
            >
              <div style="display: flex; align-items: center; justify-content: center; width:100%;">
                <img :src="'data:image/jpeg;base64,' + imgPopUp" style="height: 100%; width: 29%; border-radius: 10px;">
              </div>
              <div class="container-buttons-form pt-3">
                <button class="button-cancel" @click="closePopUpMedia">Fechar</button>
              </div>
        </b-modal>
    </div>
    <div class="container_img" v-else>
      <img  class="img_notFound" :src="notFound">
      <div class="titulo_sem_registro">Nenhum registro encontrado!</div>
    </div>
</template>

<script>

import ActionsForm from '@/shared/mixins/actionsForm'
import { loading } from '@/shared/utils/UIHelper'
import ImageNotFound from '../../../../../../../../../static/img/qma/semDados.svg'

export default {
  props: ['isPdf', 'qma', 'listWithImg'],
  name: 'templateTable',
  mixins: [ActionsForm],
  components: {},
  data () {
    return {
      openSections: [],
      isApprove: false,
      dataImg: [
      ],
      nota: 1,
      status: 0,
      lengthMidias: 0,
      templateQma: {},
      imgPopUp: null,
      notFound: ImageNotFound
    }
  },

  watch: {
  },

  mounted () {
  },
  methods: {
    downloadBase64File (base64String, fileName, mimeType) {
      const link = document.createElement('a')
      link.href = 'data:' + mimeType + ';base64,' + base64String
      console.log('data:' + mimeType + ';base64,' + base64String)

      link.download = fileName // O nome do arquivo precisa incluir a extensão.
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    },
    getFileDetails (base64String, extensao, baseFileName) {
      // Exemplo de tipos MIME para arquivos comuns
      const mimeTypes = {
        '.xlsx': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        '.pdf': 'application/pdf',
        '.png': 'image/png',
        '.jpg': 'image/jpeg',
        '.jpeg': 'image/jpeg',
        '.docx': 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
        '.pptx': 'application/vnd.openxmlformats-officedocument.presentationml.presentation',
        '.xls': 'application/vnd.ms-excel'
      }

      // Determinar o tipo MIME com base na extensão fornecida
      const mimeType = mimeTypes[extensao.toLowerCase()] || 'application/octet-stream'

      // Validar a extensão e ajustar se necessário
      let fileExtension = extensao.startsWith('.') ? extensao : `.${extensao}`

      // Compor o nome do arquivo
      const fileName = baseFileName + fileExtension

      // Chamar a função de download com os parâmetros corretos
      this.downloadBase64File(base64String, fileName, mimeType)
    },
    async onLoad (value) {
      if (value !== undefined) {
        this.templateQma = value
      }
      loading.pop()
    },
    toggleSection (index) {
      const i = this.openSections.indexOf(index)
      if (i === -1) {
        this.openSections.push(index)
      } else {
        this.openSections.splice(i, 1)
      }
    },
    PopUpQmaRepForm (value) {
      this.isApprove = value
      this.$refs['approveForm'].show()
    },
    closePopUp () {
      this.$refs['approveForm'].hide()
    },
    popUpMidias () {
      this.$refs['mediasQma'].show()
    },
    closeMedias () {
      this.$refs['mediasQma'].hide()
    },
    openPopUpMedia (base64) {
      this.imgPopUp = base64
      this.$refs['popupimgfull'].show()
    },
    closePopUpMedia () {
      this.imgPopUp = null
      this.$refs['popupimgfull'].hide()
    }
  }
}

</script>

<style scoped>
.icon-file {
  background-color: #f3f3f3;
  padding: 10px;
  width: 5rem;
  height: 5rem;
  border-radius: 10px;
}
.icone-img {
  height: 100%;
  border-radius: 10px 10px 0 0;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.edit-img{
  height: 34px;
  top: 30px;
  z-index: 5;
  right: 0px;
  width: 40px;
  color: white;
  background-color: #008148;
  border-radius: 8px 0px 0px 8px;
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}
.img-body{
  width: 100%;
  height: 12rem;
  border-radius: 10px;
  position: relative;
  transition: 400ms;
  cursor: pointer;
}
.img-descricao{
  width: 100%;
  border-radius: 0 0 10px 10px ;
  cursor: pointer;
}

.descricao{
  height: fit-content;
  width: 100%;
  color: white;
  background-color: #008148;
  display: flex;
  padding: 7px;
  justify-content: center;
  align-items: center;
  border-radius: 0 0 10px 10px ;
  cursor: pointer;
}
.img-container{
  width: calc(95% / 4);
  cursor: pointer;
}
.group-image {
  padding: 1rem;
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
  break-inside: avoid;
}
.closePopup{
  display: flex;
  height: 1rem;
  justify-content: flex-end;
}
.container-buttons-form{
  display: flex;
  justify-content: center;
  align-items: center;
  gap:15px;
  flex-direction: column;
}
    .button-cancel,.button-save{
    outline: transparent;
    border: transparent;
    border-radius: 4px;
    text-transform: uppercase;
    width: 190px;
    height: 40px;
  }
  .button-cancel{
    background-color: #008148;
    color: #ffffff;
  }
  .button-save{
    background-color: #008148;
    color: white;
  }
    .body{
      width: 100%;
    }
  .font{
        color: #666666;
        font-family:'Segoe UI';
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: 27px;
    }
    .add{
      width: 20%;
      cursor: pointer;
      display: flex;
      justify-content: end;
    }
    .cursor {
      cursor: pointer;
    }
      .img_notFound{
    width: 20%;
    height: fit-content;
  }
  .titulo_sem_registro {
    margin-top: 1rem;
    font: normal normal normal 28px/33px Segoe UI;
    color: #008148;
  }
  .container_img{
    display: flex;
    justify-content: center;
    align-content: center;
    width: 100%;
    margin-top: 5rem;
    margin-bottom: 5rem;
    align-items: center;
    flex-direction: column;
  }

</style>



// WEBPACK FOOTER //
// src/views/private/qma/inqueryQma/components/details/mediasQma/components/mediasListQma.vue